import {
    BoxIconLine,
    DollarLineIcon
} from "../../icons";

// Função para formatar valores como moeda brasileira
const formatCurrency = (value: number): string => {
    return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

interface FinanceMetricsProps {
    available: number;
    pending: number;
    reserved: number;
    total: number;
}

export default function FinanceMetrics({ available, pending, reserved }: FinanceMetricsProps) {
    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-6">

            {/* <!-- Metric Item Start --> */}
            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                        <DollarLineIcon className="text-gray-800 size-6 dark:text-white/90" />
                    </div>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        Disponível
                    </span>
                </div>
                <div className="flex items-end justify-between mt-4">
                    <div>
                        <h4 className="mt-2 me-1 font-bold text-gray-800 text-lg dark:text-white/90 whitespace-nowrap">
                            {formatCurrency(available)}
                        </h4>
                    </div>
                </div>
            </div>
            {/* <!-- Metric Item End --> */}

            {/* <!-- Metric Item Start --> */}
            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                        <BoxIconLine className="text-gray-800 size-6 dark:text-white/90" />
                    </div>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        Pendente
                    </span>
                </div>
                <div className="flex items-end justify-between mt-4">
                    <div>
                        <h4 className="mt-2 me-1 font-bold text-gray-800 text-lg dark:text-white/90 whitespace-nowrap">
                            {formatCurrency(pending)}
                        </h4>
                    </div>
                </div>
            </div>
            {/* <!-- Metric Item End --> */}

            {/* <!-- Metric Item Start --> */}
            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                        <BoxIconLine className="text-gray-800 size-6 dark:text-white/90" />
                    </div>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        Reservado
                    </span>
                </div>
                <div className="flex items-end justify-between mt-4">
                    <div>
                        <h4 className="mt-2 me-1 font-bold text-gray-800 text-lg dark:text-white/90 whitespace-nowrap">
                            {formatCurrency(reserved)}
                        </h4>
                    </div>
                </div>
            </div>
            {/* <!-- Metric Item End --> */}
        </div>
    );
}